import React, { ReactElement } from "react";
import { screens } from "../app/data/app";
import { useAppSelector } from "../app/hooks";
import { CommonState } from "../app/interfaces/common";

export const Bg = (): ReactElement => {
  const {screen, code} = useAppSelector((state: CommonState) => state.app)

  return (
    <>
      {(screen === screens.WELCOME || screen === screens.RULES) && <div className={'gear gear_30'}/>}
      {screen === screens.PROMO_CODE && code === 1 && <div className={'gear gear_10'}/>}
      {screen === screens.PROMO_CODE && code === 2 && <div className={'gear gear_15'}/>}
      {screen === screens.PROMO_CODE && code === 3 && <div className={'gear gear_30'}/>}
      {screen === screens.AUTH && <div className={'auth-gears_mob'}/>}
    </>
  )
}